// extracted by mini-css-extract-plugin
module.exports = {"container":"Stack__container___5cc2c","main":"Stack__main___bI16h","content":"Stack__content___WKaEz","sidebar":"Stack__sidebar___w0b6p"};